import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './NavbarMobile.scss';
import { faArrowUp, faClock, faImages, faPeopleGroup, faPhone, faStar, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
export default function NavbarMobile() {
    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > window.innerHeight);
        });
    });

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <>
            <div className='bottom-right'>
                <ul class="menu-list tw-text-center">
                    <li className={`navbar-menu-icons tw-hidden ${scroll ? "block" : ""}`}>
                        <a href="#/" onClick={scrollToTop} className='inline-block align-text-middle'>
                            <FontAwesomeIcon icon={faArrowUp} />
                        </a>
                    </li>
                    <li className='navbar-menu-icons'>
                        <a href="#about-us">
                            <FontAwesomeIcon icon={faPeopleGroup} />
                        </a>
                    </li>
                    <li className='navbar-menu-icons'>
                        <a href='#menu'>
                            <FontAwesomeIcon icon={faUtensils} />
                        </a>
                    </li>
                    {/* <li className='navbar-menu-icons'>
                        <a href='#special'>
                            <FontAwesomeIcon icon={faStar} />
                        </a>
                    </li> */}
                    <li className='navbar-menu-icons'>
                        <a href='#gallery'>
                            <FontAwesomeIcon icon={faImages} />
                        </a>
                    </li>
                    <li className='navbar-menu-icons'>
                        <a href='#timing'>
                            <FontAwesomeIcon icon={faClock} />
                        </a>
                    </li>
                    <li className='navbar-menu-icons'>
                        <a href='#contact'>
                            <FontAwesomeIcon icon={faPhone} />
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}